jQuery(document).ready(function ($) {


/**
 * 
 * PAGINA MODIFICA OGGETTO
 * 
 * 
 * 
 */    
    
    $("#button-modifica-oggetto").click(function () {
        $('#messageUpdateObject').html('');
        $("#messageUpdateObject").removeClass('alert-danger');
        $("#messageUpdateObject").removeClass('alert-success');
        $("#messageUpdateObject").hide();

        var reg_categoria = $('#modifica-oggetto-categoria').val();
        var reg_titolo = $('#modifica-oggetto-titolo').val();
        var reg_descrizione= $('#modifica-oggetto-descrizione').val();
        var reg_idoggetto= $('#modifica-oggetto-idoggetto').val();
        var reg_taglia= $('#modifica-oggetto-taglia-oggetto').val();
        var faiAjax = true;
        if (reg_titolo == '')
        {
            rimuovi_stato('#modifica-oggetto-titolo');
            stato_errore('#modifica-oggetto-titolo', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#modifica-oggetto-titolo');
            stato_success('#modifica-oggetto-titolo');
        }
        if (reg_descrizione == '')
        {
            rimuovi_stato('#modifica-oggetto-descrizione');
            stato_errore('#modifica-oggetto-descrizione', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#modifica-oggetto-descrizione');
            stato_success('#modifica-oggetto-descrizione');
        }
        if (reg_categoria == null || reg_categoria == '')
        {
            rimuovi_stato('#modifica-oggetto-categoria');
            stato_errore('#modifica-oggetto-categoria', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#modifica-oggetto-categoria');
            stato_success('#modifica-oggetto-categoria');
        }
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            // carico ilform tramit formdata per upload del file
            form.append('categoria', reg_categoria);
            form.append('descrizione', reg_descrizione);
            form.append('titolo', reg_titolo);
            form.append('id_oggetto', reg_idoggetto);
            form.append('taglia_oggetto', reg_taglia);
            form.append('action', 'modifica_oggetto_action'); 
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                        contentType: false,
                        cache: false,
                        processData: false,
                        dataType: "html",
                url: ajax_url,                
                success: function (resp) {
                    if (resp === '1')
                    {
                        
                        $("#messageUpdateObject").html('Oggetto Modificato con Successo');
                        $("#messageUpdateObject").addClass('alert-success');
                        $("#messageUpdateObject").show();
                    }
                    else
                    {
                        $("#messageUpdateObject").html(resp);
                        $("#messageUpdateObject").addClass('alert-danger');
                        $("#messageUpdateObject").show();
                    }
                    
                    themeSpinner('hide');
                    
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageUpdateObject").html('Problemi nella modifica dell\'oggetto');
                    $("#messageUpdateObject").addClass('alert-danger');
                    $("#messageUpdateObject").show();
                }

            });
            
        }
    });
});
